import { FieldValidationError } from './csv-field-mapping';

export const normalizeHeader = (header: string): string => {
  return header
    .replace(/[^\w\s\-]/g, '')
    .trim()
    .toLowerCase();
};

export type ValidationFn = (headers: string[]) => FieldValidationError | null;

const validateFile = async (
  validationFn: ValidationFn,
  file: File
): Promise<FieldValidationError | null> => {
  //@ts-ignore
  const reader = file.stream().getReader();
  const decoder = new TextDecoder('utf-8');
  const { value } = await reader.read();

  if (!value) {
    return null;
  }

  const firstLine = decoder.decode(value, { stream: true }).split('\n')[0];
  const headers = firstLine.split(',').map((header) => normalizeHeader(header));
  return validationFn(headers);
};

export const getValidateCsvFileHeaders = (options: {
  validateHeaders: ValidationFn;
  onErrors: (errors: FieldValidationError) => void;
  onSuccess: (file: File) => void;
}): ((file: File) => Promise<void>) => {
  return async (file: File): Promise<void> => {
    const errors = await validateFile(options.validateHeaders, file);
    if (!!errors) {
      options.onErrors(errors);
    } else {
      options.onSuccess(file);
    }
  };
};
